// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhs_ss","PhotoTitleEditForm__cancelBtn":"iy_b bhs_sw bhs_sv"};